import { SimpleGrid, Tabs } from '@mantine/core';
import { InfoEmailCard } from './InfoEmailCard';
import { InfoPaymentMethodCard } from './InfoPaymentMethodCard';
import { InfoPhoneCard } from './InfoPhoneCard';
import { InfoUsernameCard } from './InfoUsernameCard';
export const AccountInfoTab: React.FC = () => {
  return <Tabs.Panel value="info">
      <SimpleGrid cols={{
      base: 1,
      md: 2
    }}>
        <InfoUsernameCard />
        <InfoPhoneCard />
        <InfoEmailCard />
        <InfoPaymentMethodCard />
      </SimpleGrid>
    </Tabs.Panel>;
};